import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {filter, map} from "rxjs/operators";
import {OidcSecurityService, UserDataResult} from "angular-auth-oidc-client";
import {Authority, UserData} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {UserDataService} from "./user-data.service";
import {CustomUserDataResult} from "../types/openid-connect-userinfo";

@Injectable({
  providedIn: 'root',
})
export class SecurityService {

  private oidcSecurityService: OidcSecurityService = inject(OidcSecurityService);
  private userDataService: UserDataService = inject(UserDataService);

  constructor() {
  }

  checkAuth() {
    return this.oidcSecurityService.checkAuth();
  }

  isLoggedIn$(): Observable<boolean> {
    // return this.user$.pipe(map(user => !!user));
    return this.oidcSecurityService
      .isAuthenticated$
      .pipe(map(value => value.isAuthenticated));
  }

  user$(): Observable<UserData> {
    return this.oidcSecurityService
      .userData$
      .pipe(map(({userData}) => userData));
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens()
      .subscribe((result) => {
        console.log(result);
        this.oidcSecurityService.logoffLocalMultiple();
      });
  }

  public isAnyAuthority(u: (UserDataResult | CustomUserDataResult), authorities: Authority[]): boolean {
    if (u) {
      let userAuthorities: string[] = u?.userData?.resource_access?.[environment.clientId]?.roles || []
      let realmRole: string[] = u?.userData?.realm_access?.roles || []
      userAuthorities = [...userAuthorities, ...realmRole]
      return this.hasAny(authorities, userAuthorities);
    }
    return false;
  }

  public hasAnyAuthority(checkAuthorities: Authority[]): Observable<boolean> {
    return this.oidcSecurityService.userData$
      .pipe(filter(e => e?.userData),
        map(u => {
          let userAuthorities: Authority[] = u.userData?.resource_access?.[environment.clientId]?.roles || [];
          let realmRole: Authority[] = u.userData?.realm_access?.roles || [];
          userAuthorities = [...userAuthorities, ...realmRole];
          if (this.hasAny(checkAuthorities, userAuthorities)) {
            return true
          } else {
            return false
          }
        }))
  }

  public hasAnyAuthorityExcept(checkAuthorities: Authority[], except: Authority[]): Observable<boolean> {
    return this.oidcSecurityService.userData$
      .pipe(
        filter(e => e?.userData),
        map(u => {
          let userAuthorities: Authority[] = u.userData?.resource_access?.[environment.clientId]?.roles || [];
          let realmRole: Authority[] = u.userData?.realm_access?.roles || [];
          userAuthorities = [...userAuthorities, ...realmRole];
          return this.hasAnyExcept(checkAuthorities, userAuthorities, except);
        }),
      );
  }

  private hasAny(authorityList: Authority[], authorities: string[] = []): boolean {
    if (authorities) {
      let hasAuthority = authorities.some(e => authorityList.some(ex => e == ex));
      return hasAuthority;
    } else {
      return false;
    }
  }

  private hasAnyExcept(authorityList: Authority[], authorities: string[] = [], except: Authority[]): boolean {
    if (authorities) {
      if (except?.length) {
        let notContainsExcludeList = !authorities.some(e => except.some(ex => e == ex));
        let hasAnyAuthority = authorities.some(e => authorityList.some(ex => e == ex));
        return hasAnyAuthority && notContainsExcludeList;
      }
      return authorities.some(e => authorityList.some(ex => e == ex));
    } else {
      return false;
    }
  }
}
